/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Wed Feb 12 2025
 **/
import { create } from "zustand";

type DocumentViewerStoreProps = {
	scale: number;
	prevScale: number;
	minScale: number;
	page: number;
	play: boolean | undefined;
	time: number;
	volume: number;
	setScale: (scale: number) => void;
	setMinScale: (minScale: number) => void;
	resetScale: () => void;
	setPage: (page: number) => void;
	setPlay: (play: boolean) => void;
	setTime: (time: number) => void;
	setVolume: (volume: number) => void;
	resetVideoStatus: () => void;
};

const useDocumentViewerStore = create<DocumentViewerStoreProps>((set) => ({
	scale: 1,
	prevScale: 1,
	minScale: 1,
	page: 0,
	play: undefined,
	time: 0,
	volume: 1,
	setScale: (scale) => set((state) => ({ scale, prevScale: state.scale })),
	setMinScale: (minScale) => set({ minScale }),
	resetScale: () => set({ scale: 1, prevScale: 1, minScale: 1 }),
	setPage: (page) => set({ page }),
	setPlay: (play) => set({ play }),
	setTime: (time) => set({ time }),
	setVolume: (volume) => set({ volume }),
	resetVideoStatus: () => set({ play: undefined, time: 0, volume: 1 })
}));

export default useDocumentViewerStore;
